import { TimeZoneSiteSettingCtrl, ITimeZoneSiteSettingScope } from '../controllers/TimeZoneSiteSettingCtrl';
import { Module } from '../Module';

Module.instance().directive('tbTimeZoneSiteSetting', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: 'true',
      templateUrl: 'timeZoneSiteSetting.html',
      scope: {
        timeZoneId: '=',
        useDefaultTimeZone: '='
      },
      require: '^?tbSettingsCoordinator',
      controller: TimeZoneSiteSettingCtrl,
      link: ($scope: ITimeZoneSiteSettingScope, form: JQuery) => {
        $scope.sharedForm.registerFormStateByName($scope.localForm, 'updateDefaultSiteTimeZone');
      }
    };
  }
]);
